module.exports = __webpack_public_path__ + "img/vertical_1_1_3009.c928aa44.png";